import { render, staticRenderFns } from "./GlassDamagesReparationsQuestion.vue?vue&type=template&id=24916dbb&scoped=true"
import script from "./GlassDamagesReparationsQuestion.vue?vue&type=script&lang=ts"
export * from "./GlassDamagesReparationsQuestion.vue?vue&type=script&lang=ts"
import style0 from "./GlassDamagesReparationsQuestion.vue?vue&type=style&index=0&id=24916dbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24916dbb",
  null
  
)

export default component.exports